import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { EnrollmentCodeService } from "app/shared/services/enrollment-code.service";
import { of } from "rxjs";
import { map, catchError } from "rxjs/operators";

export const enrollmentCodeGuard: CanActivateFn = (route) => {
  const enrollmentCodeService = inject(EnrollmentCodeService);

  const enrollmentCode = route.queryParamMap.get("enrollmentCode");

  if (!enrollmentCode) {
    return true;
  }

  return enrollmentCodeService.validateCode(enrollmentCode).pipe(
    map((res) => {
      if (res) {
        return true;
      }
      window.location.href = `https://cariloop.com`;
      return false;
    }),
    catchError(() => {
      window.location.href = `https://cariloop.com`;
      return of(false);
    }),
  );
};
